import { render, staticRenderFns } from "./SaveChangesBar.vue?vue&type=template&id=75fdcdb4&"
import script from "./SaveChangesBar.vue?vue&type=script&lang=ts&"
export * from "./SaveChangesBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports